import React, { useState, useEffect, useRef } from 'react';

function FilesCard({
  attachments = [],
  loading = false,
  error = '',
  onUpload,
  onDelete,
  canManage = false,
}) {
  const [uploading, setUploading] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null);
  const fileInputRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!openMenuId) return undefined;
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) setOpenMenuId(null);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [openMenuId]);

  const handleFileChange = async (event) => {
    const file = event.target.files && event.target.files[0];
    event.target.value = '';
    if (!file || !onUpload || uploading) return;
    setUploading(true);
    try {
      await onUpload(file);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="cdp-card cdp-files-card">
      <div className="cdp-card-header-row">
        <h2 className="cdp-card-title">Files</h2>
        {canManage && onUpload && (
          <>
            <input ref={fileInputRef} type="file" style={{ display: 'none' }} onChange={handleFileChange} />
            <button
              type="button"
              className="cdp-files-add"
              disabled={uploading}
              onClick={() => fileInputRef.current && fileInputRef.current.click()}
            >
              {uploading ? 'Uploading…' : '+ Add'}
            </button>
          </>
        )}
      </div>

      {loading && attachments.length === 0 && (
        <div className="cdp-files-empty" role="status">Loading files…</div>
      )}
      {error && <div className="text-danger small py-2">{error}</div>}
      {!loading && !error && attachments.length === 0 && (
        <div className="cdp-files-empty">No files yet.</div>
      )}

      {attachments.length > 0 && (
        <div className="cdp-files-list">
          {attachments.map((att) => (
            <div key={att.id} className="cdp-files-row">
              <span className="cdp-files-icon"><i className="fal fa-file" aria-hidden="true" /></span>
              <div className="cdp-files-row-body">
                <a
                  href={att.download_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cdp-files-name"
                >
                  {att.file_name}
                </a>
                <span className="cdp-files-meta">
                  {[att.human_size, att.human_created_at].filter(Boolean).join(' · ')}
                </span>
              </div>
              {canManage && onDelete && (
                <div
                  ref={openMenuId === att.id ? menuRef : null}
                  className="position-relative"
                >
                  <button
                    type="button"
                    className="btn btn-link btn-sm p-0 text-muted"
                    aria-label="More file actions"
                    onClick={() => setOpenMenuId((current) => (current === att.id ? null : att.id))}
                  >
                    <i className="fal fa-ellipsis-v" aria-hidden="true" />
                  </button>
                  {openMenuId === att.id && (
                    <div className="cdp-files-menu">
                      <button
                        type="button"
                        className="cdp-activity-menu-item cdp-activity-menu-item--danger"
                        onClick={() => { setOpenMenuId(null); onDelete(att); }}
                      >
                        <i className="fal fa-trash-alt" aria-hidden="true" />
                        <span>Delete file</span>
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default FilesCard;
